/** Lido WithdrawalQueueERC721 — enumeration + status getters.
 *  Address on chain 1: `0x889edc2edab5f40e902b864ad4d7ade8e412f9b1`. */
export const LidoWithdrawalQueueAbi = [
  {
    name: 'getWithdrawalRequests',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: '_owner' }],
    outputs: [{ type: 'uint256[]' }],
  },
  {
    name: 'getWithdrawalStatus',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256[]', name: '_requestIds' }],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint256', name: 'amountOfStETH' },
          { type: 'uint256', name: 'amountOfShares' },
          { type: 'address', name: 'owner' },
          { type: 'uint256', name: 'timestamp' },
          { type: 'bool', name: 'isFinalized' },
          { type: 'bool', name: 'isClaimed' },
        ],
      },
    ],
  },
  {
    name: 'getLastFinalizedRequestId',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
